import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import {BaseURL} from "../../../../Files/BaseURL";

const WithdrawMoney = () => {
    const navigate=useNavigate()
    const [info, setInfo] = useState({});

    const userInfo = async () => {
        const authToken = localStorage.getItem("p@token");
        const res = await fetch(`${BaseURL}/api/payment/account/pay-info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "auth-token": authToken,
            }
        });
        return await res.json();
    };


    useEffect(() => {
        userInfo().then((result) => {
            setInfo(result);
        });
    }, []);



    return (
        <div className="flex justify-center font-pop items-center py-20">
            <div className="mx-6 bg-white max-w-md w-full p-4 md:p-8 rounded-lg shadow-md">
                <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Withdraw money</h2>
                <p className="text-gray-600 mb-6 text-sm md:text-base max-w-sm">Select where you want to send money</p>
                {/* <form> */}

                <div className="flex flex-col font-pop gap-4">
                    <div className="flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer" onClick={() => { navigate('/user-dashboard/withdraw/amount',{state:info}) }}>
                        <img src="../../Assets/Accounts/Paypal.png" alt="" className='w-6 md:w-8 h-6 md:h-8'  />
                        <p className='text-base md:text-lg font-medium'>PayPal account ({info.AttachedPaypal?.Email.substring(0,4)} ****)</p>
                    </div>
                    {/*<div className="flex flex-row border-2 items-center border-[#E9E9E9] py-2 md:py-4 px-2 md:px-6 rounded-lg gap-2 cursor-pointer" onClick={() => { navigate('/user-dashboard/withdraw/amount') }}>*/}
                    {/*    <img src="../../Assets/Accounts/card.png" alt="" className='w-6 md:w-8 h-6 md:h-8'  />*/}
                    {/*    <p className='text-base md:text-lg font-medium'>Credit card ({info.AttachedCard?.Name})</p>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    )
}

export default WithdrawMoney